import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsApple, BsGithub, BsArrowUpRight, BsGooglePlay, BsDownload } from "react-icons/bs";

function ProjectCards(props) {
  const getDemoLinkContent = (link) => {
    if (!link) return null;
    
    if (link.includes("apps.apple.com")) {
      return {
        text: "App Store",
        icon: <BsApple className="me-2" />
      };
    }
    if (link.includes("play.google.com")) {
      return {
        text: "Play Store",
        icon: <BsGooglePlay className="me-2" />
      };
    }
    if (link.includes("drive.google.com")) {
      return {
        text: "Download APK",
        icon: <BsDownload className="me-2" />
      };
    }
    return {
      text: "Visit Site",
      icon: <BsArrowUpRight className="me-2" />
    };
  };

  const demoContent = getDemoLinkContent(props.demoLink);

  return (
    <Card className="project-card-view">
      <Card.Body className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div>
            {props.demoLink ? (
              <a 
                href={props.demoLink} 
                target="_blank" 
                rel="noreferrer" 
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Card.Title className="project-title-modern">{props.title}</Card.Title>
              </a>
            ) : (
              <Card.Title className="project-title-modern">{props.title}</Card.Title>
            )}
            <p className="project-subtitle-modern">{props.subtitle}</p>
          </div>
          <div className="project-links-modern">
            {props.ghLink && !props.noGithub && (
              <a href={props.ghLink} target="_blank" rel="noreferrer" className="project-link-icon">
                <BsGithub />
              </a>
            )}
          </div>
        </div>
        
        <Card.Text className="project-description-modern">
          {props.description}
        </Card.Text>

        <div className="mt-auto">
          <div className="tech-stack-container mb-4">
            {props.techStack && props.techStack.map((tech, index) => (
              <span key={index} className="tech-badge">
                {tech}
              </span>
            ))}
          </div>

          <div className="d-flex flex-wrap gap-2">
            {props.demoLink && demoContent && (
              <Button
                as="a"
                variant="primary"
                href={props.demoLink}
                target="_blank"
                rel="noreferrer"
                className="modern-btn"
              >
                {demoContent.icon}
                {demoContent.text}
              </Button>
            )}
            {props.appStoreLink && (
              <Button
                as="a"
                variant="dark"
                href={props.appStoreLink}
                target="_blank"
                rel="noreferrer"
                className="modern-btn btn-apple"
              >
                <BsApple className="me-2" />
                App Store
              </Button>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;